import { animate, AnimationEvent, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Output } from '@angular/core';

type ExpandedPanelButton = 'close' | 'collapse';

@Component({
  selector: 'expanded-panel',
  templateUrl: './expanded-panel.component.html',
  styleUrls: ['./expanded-panel.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class ExpandedPanelComponent {
  @Output() closed = new EventEmitter<void>();
  @Output() closedAll = new EventEmitter<void>();
  expanded = true;

  buttonsClicked: Record<ExpandedPanelButton, boolean> = {
    close: false,
    collapse: false
  };

  onButtonClicked(button: ExpandedPanelButton) {
    this.expanded = false;
    this.buttonsClicked[button] = true;
  }

  onAnimDone(e: AnimationEvent): void {
    if (e.toState === 'void') {
      if (this.buttonsClicked.collapse) this.closed.emit();
      else if (this.buttonsClicked.close) this.closedAll.emit();
    }
  }
}
